import { connect } from 'react-redux';
import { authLogout } from '../../actions/auth';

import Sidebar from './Sidebar';

const mapDispatchToProps = {
  logout: authLogout,
};

const mapStateToProps = state => ({
  profile: state.auth.profile,
  perms: state.auth.perms,
});

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);



// WEBPACK FOOTER //
// src/components/Sidebar/SidebarContainer.js